import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserTable from "./userTable";
import { getUsers, searchUser } from "../../../api/lead";
import {
  InputGroup,
  FormControl,
  Button,
  Dropdown,
  Form,
} from "react-bootstrap";

const Users = () => {
  const [loadingData, setLoadingData] = useState(true);
  const naviagte = useNavigate();
  const [users, setUsers] = useState([]);
  const [filtered_users, setFilteredUsers] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([
    "Admin",
    "Student",
    "Manager",
    "Agent",
  ]);
  const modalRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    source: "",
    lead_type: "",
    parent_name: "",
    studentClass: "",
    course: "",
    phone: "",
    city: "",
    country: "",
    message: "",
    assignToSelf: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const fetchData = async (query) => {
    setLoadingData(true);
    try {
      const [usersData] = await Promise.all([getUsers(query)]);
      if (usersData.status) {
        setUsers(usersData.data);
        setFilteredUsers(usersData.data);
        setLoadingData(false);
      }
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearchClick = async (type) => {
    setLoadingData(true);
    let returnData;
    if (searchValue == "") {
      returnData = await getUsers();

      setUsers(returnData.data);
      setFilteredUsers(returnData.data);
      setLoadingData(false);
    } else {
      let data = {
        query: searchValue,
        type: type,
      };
      returnData = await searchUser(data);
      setUsers(returnData.data);
      setFilteredUsers(returnData.data);
      setLoadingData(false);
    }
  };

  const handleSelect = (role) => {
    let updatedRoles;
    if (selectedRoles.includes(role)) {
      updatedRoles = selectedRoles.filter((s) => s !== role);
    } else {
      updatedRoles = [...selectedRoles, role];
    }

    setSelectedRoles(updatedRoles);
    const filterUsers = users.filter((user) =>
      updatedRoles.includes(user.user_type)
    );
    setFilteredUsers(filterUsers);
  };

  const handleNavigate = (url) => {
    naviagte("/home/add-user");
  };

  return loadingData ? (
    <div className="d-flex justify-content-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <div className="lead-home-container">
      <div className="home-filter-container mt-5">
        <div className="row">
          {/* Search Input */}
          <div className="col">
            <InputGroup className="mb-3">
              <FormControl
                placeholder="Phone Number"
                aria-label="Phone Number"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchClick("searchBar");
                  }
                }}
              />
              <Button
                className="primary-button"
                variant="primary"
                id="lead-search-button"
                onClick={() => handleSearchClick("searchBar")}
              >
                Search
              </Button>
            </InputGroup>
          </div>

          {/* Checkbox Dropdown */}
          {/* <div className="col">
            <Dropdown>
              <Dropdown.Toggle
                className="primary-button"
                variant="primary"
                id="dropdownMenuButton"
              >
                User Type
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ padding: "10px" }}>
                <Form.Check
                  type="checkbox"
                  id="Checkme1"
                  label="Students"
                  defaultChecked
                  onClick={() => handleSelect("Student")}
                />
                <Form.Check
                  type="checkbox"
                  id="Checkme1"
                  label="Agent"
                  defaultChecked
                  onClick={() => handleSelect("Agent")}
                />
                <Form.Check
                  type="checkbox"
                  id="Checkme2"
                  label="Manager"
                  defaultChecked
                  onClick={() => handleSelect("Manager")}
                />
                <Form.Check
                  type="checkbox"
                  id="Checkme3"
                  label="Admin"
                  defaultChecked
                  onClick={() => handleSelect("Admin")}
                />
              </Dropdown.Menu>
            </Dropdown>
          </div> */}

          <div className="col">
            <Dropdown>
              <Dropdown.Toggle
                className="primary-button"
                variant="primary"
                id="dropdownMenuButton"
              >
                User Status
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ padding: "10px" }}>
                <Form.Check
                  type="checkbox"
                  id="Checkme1"
                  label="Active"
                  defaultChecked
                  onClick={() => handleSelect("Active")}
                />
                <Form.Check
                  type="checkbox"
                  id="Checkme1"
                  label="On Break"
                  defaultChecked
                  onClick={() => handleSelect("Break")}
                />
                <Form.Check
                  type="checkbox"
                  id="Checkme2"
                  label="Blocked"
                  defaultChecked
                  onClick={() => handleSelect("Blocked")}
                />
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* Buttons */}
          <div className="col">
            <Button
              variant="primary primary-button"
              className="mx-2"
              onClick={() => {
                handleNavigate("/home/add-user");
              }}
            >
              Add New User
            </Button>
          </div>
        </div>
      </div>
      <div className="home-list-table mt-4">
        <UserTable users={filtered_users} />
      </div>
    </div>
  );
};

export default Users;
